import { AppTagItemEntity } from '@datachain/ui-sdk/components/dc-types';
import { immerable } from 'immer';
import { OrderedSet } from 'immutable';

export interface IProjectItemEntity {
	id: number;
	uuid: string;
	label: string;
	description: string;
	version: string;
	tags: OrderedSet<AppTagItemEntity>;
}

const entityDefaults: IProjectItemEntity = {
	id: -1,
	uuid: '-1',
	label: '',
	description: '',
	version: '',
	tags: OrderedSet(),
};

export class ProjectItemEntity implements IProjectItemEntity {
	private [immerable] = true;
	public id = entityDefaults.id;
	public uuid = entityDefaults.uuid;
	public label = entityDefaults.label;
	public description = entityDefaults.description;
	public version = entityDefaults.version;
	public tags = entityDefaults.tags;

	public static build(
		params: Partial<IProjectItemEntity> = {}
	): ProjectItemEntity {
		const instance = new ProjectItemEntity();
		instance.id = params.id ?? entityDefaults.id;
		instance.uuid = params.uuid ?? entityDefaults.uuid;
		instance.label = params.label ?? entityDefaults.label;
		instance.description = params.description ?? entityDefaults.description;
		instance.version = params.version ?? entityDefaults.version;
		instance.tags = params.tags ?? entityDefaults.tags;

		return instance;
	}
}
